export default __webpack_public_path__ + "a7629910d13716b7080c4799ab771d7c.ttf";